"use client"

import styled from "@emotion/styled"
import { Box } from "@mui/material"
import Image from "next/image"
import { mediaQueries } from "ui"
import { colors, sizes } from "ui/theme/theme"
import BlockWrapper from "../../common/BlockWrapper"

// Styled components
const StyledFormCard = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 764px;
  margin: 0 auto;
  padding: ${sizes.baseTriple};
  border-radius: 30px;
  background-color: ${colors.white};
  gap: ${sizes.baseDouble};
  box-shadow: -4px 8px 30px 0px rgba(2, 1, 64, 0.12);
  position: relative;
  margin-top: 70px;

  ${mediaQueries.desktop} {
    padding: ${sizes.baseSix};
    margin-top: 70px;
  }
`

const StyledShapeWrapper = styled.div`
  display: none;
  ${mediaQueries.desktop} {
    display: block;
    position: absolute;
    right: 50px;
    top: -70px;
    width: 100%;
    z-index: -1;
    height: 622px;
    width: 629px;
    top: -70px;
  }
`

interface PolicyFormCardProps {
  id?: string
  children: React.ReactNode
  className?: string
}

const BlockCardContainerWithShape = ({
  id,
  children,
  className,
}: PolicyFormCardProps) => {
  return (
    <BlockWrapper id={id} className={className}>
      <StyledFormCard>
        {children}
        <StyledShapeWrapper>
          <Image
            fill
            src={"/formBackgroundShape.svg"}
            alt="form Background Shape"
          />
        </StyledShapeWrapper>
      </StyledFormCard>
    </BlockWrapper>
  )
}

export default BlockCardContainerWithShape
